import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TestConference } from '../../components/SelfTest/WelcomeScreen';
import { setBaseUrl } from '../../redux/slices/config';

const SelfTest = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBaseUrl(process.env.NEXT_PUBLIC_STREAMGO_API as string));
  }, [dispatch]);

  return <TestConference />;
};

export default SelfTest;
